import React from 'react';
import { useAnalytics } from '../../../../hooks/use-analytics';
import { ActivityIndicator } from '../../../common/activity-indicator/activity-indicator';
import shareIcon from '../../../../assets/share-icon.svg';

interface Props {
    logFileResponseLoading: boolean;
    ctaLabel1?: string;
    logFiles: FileList | null | undefined;
    logFileErrorMessage: string;
    warning: string;
    greenCheck: string;
    ariaLabel?: string;
    addFiles: (event: any) => void;
    pendingLogFileErrorMessage?: string;
    uploadPending?: string;
    xmlVinMismatchMessage?: string;
}

const SyncInstallUpdatesCardFileUpload = (props: Props) => {
    const {
        logFileResponseLoading,
        ctaLabel1,
        logFiles,
        logFileErrorMessage,
        warning,
        greenCheck,
        addFiles,
        pendingLogFileErrorMessage,
        uploadPending,
        xmlVinMismatchMessage,
    } = props;
    const [fireEvents] = useAnalytics();

    const buttonDisabled = pendingLogFileErrorMessage !== '';

    return (
        <>
            <div className="sync-file-uploader">
                <label
                    className={`sync-file-upload-label${
                        buttonDisabled ? ' disabled' : ''
                    }`}
                >
                    <span className="sync-browse-label">
                        {ctaLabel1}
                        <img
                            src={shareIcon}
                            className="share-icon"
                            loading="lazy"
                            alt="share icon"
                        />
                    </span>
                    <input
                        className="browse-input"
                        data-testid="logFileInput"
                        id="sync-file-upload-input"
                        type="file"
                        onChange={addFiles}
                        onClick={() => {
                            fireEvents(
                                'sync-browse-log-files',
                                undefined,
                                undefined,
                                false
                            );
                        }}
                        aria-label={props.ariaLabel}
                        disabled={buttonDisabled}
                    />
                </label>
            </div>

            {logFileResponseLoading ? (
                <ActivityIndicator radius="10" />
            ) : (
                <>
                    {logFiles && logFiles[0] && (
                        <>
                            <div className="sync-files-uploaded">
                                <div className="sync-file-name-container">
                                    <img
                                        className="sync-file-upload-success-icon"
                                        src={
                                            logFileErrorMessage ||
                                            pendingLogFileErrorMessage ||
                                            xmlVinMismatchMessage
                                                ? warning
                                                : greenCheck
                                        }
                                        alt="sync-file-upload-success-icon"
                                    />
                                    <div className="sync-file-name">
                                        {logFiles[0].name}
                                    </div>
                                    <div className="sync-upload-pending">
                                        {pendingLogFileErrorMessage
                                            ? uploadPending
                                            : ''}
                                    </div>
                                </div>
                                {logFileErrorMessage && (
                                    <span className="sync-upload-failure">
                                        {logFileErrorMessage}
                                    </span>
                                )}
                                {xmlVinMismatchMessage && (
                                    <span className="sync-upload-failure">
                                        {xmlVinMismatchMessage}
                                    </span>
                                )}
                            </div>
                            {pendingLogFileErrorMessage && (
                                <span className="malformed-xml-error-msg">
                                    {pendingLogFileErrorMessage}
                                </span>
                            )}
                        </>
                    )}
                </>
            )}
        </>
    );
};

export default SyncInstallUpdatesCardFileUpload;
